import { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

import { ReactComponent as IconC9 } from "../../assets/icons/vendaExcelente/icon-venda-1.svg";
import { ReactComponent as IconRS } from "../../assets/icons/vendaExcelente/icon-venda-2.svg";
import { ReactComponent as Gestaodainfo } from "../../assets/icons/gestaodainfo.svg";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function VendaExcelenteDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Gerencial");
  const [selectedValueKpi, setSelectedValueKpi] = useState("Volume C9");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [selectedGroupKpi, setSelectedGroupKpi] = useState("");
  const [singleGroupViewKpi, setSingleGroupViewKpi] = useState(false);

  const [numberCard1, setNumberCard1] = useState();
  const [numberCard2, setNumberCard2] = useState();
  const [numberCard3, setNumberCard3] = useState();
  const [numberCard4, setNumberCard4] = useState();

  const handleChange = (event) => {
    app.field("Nm_Visu_VendaEx").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  const handleChangekPI = (event) => {
    app.field("Nm_Visu_VendaEx_kpi").selectMatch(event.target.value, true);
    setSelectedValueKpi(event.target.value);
  };

  const getNumberforBigNumbers = useCallback(
    async (objectId, index) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          index === 1 && setNumberCard1(value);
          index === 2 && setNumberCard2(value);
          index === 3 && setNumberCard3(value);
          index === 4 && setNumberCard4(value);
        });
      }
    },
    [app, selections]
  );

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu_VendaEx")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
      getNumberforBigNumbers("dfbad2ae-945b-42c4-8a6c-380acede4f11", 1);
      getNumberforBigNumbers("dd5ed983-715c-4a1d-8dc2-09f32b0a7f45", 2);
      getNumberforBigNumbers("a7438ba9-bf64-49da-b595-98e40ebd2375", 3);
      getNumberforBigNumbers("e2ef4eb5-b535-41ed-8149-a50188d9bb34", 4);
    }
  }, [app, selections]);

  useEffect(() => {
    if (app) {
      const distributorsKpi = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu_VendaEx_kpi")
        : null;
      setSelectedGroupKpi(
        distributorsKpi
          ? distributorsKpi?.qSelectedCount === 1
            ? `: ${distributorsKpi.qSelected}`
            : ""
          : ""
      );
      if (distributorsKpi?.qSelected) {
        setSelectedValueKpi(distributorsKpi?.qSelected);
      }
      setSingleGroupViewKpi(distributorsKpi?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app excelente">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              <div className="container-titles">
                <h3
                  style={{
                    margin: "0px 16px 15.5px 0",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span>Venda Excelente</span>
                  <Tooltip
                    title="Vendas respeitando o prazo de compartilhamento de informações, área foco, canal foco, blocklist e range de preço."
                    TransitionProps={{ timeout: 600 }}
                    arrow
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, -14],
                            },
                          },
                        ],
                      },
                    }}
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        color: "red", // Altere para a cor desejada
                      },
                    }}
                  >
                    <Gestaodainfo />
                  </Tooltip>
                </h3>
              </div>
              <div className="adm-cards">
                <Card
                  app={app}
                  header={{
                    hardTitle: "Venda Excelente em C9",
                  }}
                  style={{
                    height: "85px",
                    justifyContent: "space-around",
                  }}
                  className={"container-card-item"}
                >
                  <div className="container-object-and-icon">
                    <p
                      className={
                        "container-card-item-object container-card-item-object-mobile"
                      }
                    >
                      {numberCard1}
                    </p>

                    <IconC9 />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "% Venda Excelente em C9",
                  }}
                  style={{
                    height: "85px",
                  }}
                  className={"container-card-item"}
                >
                  <div className="container-object-and-icon">
                    <p
                      className={
                        "container-card-item-object container-card-item-object-mobile"
                      }
                    >
                      {numberCard2}
                    </p>
                    <IconC9 />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Venda Excelente em R$",
                  }}
                  style={{
                    height: "85px",
                  }}
                  className={"container-card-item"}
                >
                  <div className="container-object-and-icon">
                    <p
                      className={
                        "container-card-item-object container-card-item-object-mobile"
                      }
                    >
                      {numberCard3}
                    </p>

                    <IconRS />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "% Venda Excelente em R$",
                  }}
                  style={{
                    height: "85px",
                  }}
                  className={"container-card-item"}
                >
                  <div className="container-object-and-icon">
                    <p
                      className={
                        "container-card-item-object container-card-item-object-mobile"
                      }
                    >
                      {numberCard4}
                    </p>

                    <IconRS />
                  </div>
                </Card>
              </div>

              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Gerencial"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={handleChange}
                  sx={{ marginLeft: "0px" }}
                >
                  <FormControlLabel
                    value="Gerencial"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#0DA9D5",
                          "&.Mui-checked": {
                            color: "#0DA9D5",
                          },
                        }}
                      />
                    }
                    label="Gerencial"
                  />

                  <FormControlLabel
                    value="Resumo"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#0DA9D5",
                          "&.Mui-checked": {
                            color: "#0DA9D5",
                          },
                        }}
                      />
                    }
                    label="Resumo"
                  />

                  <FormControlLabel
                    value="Detalhamento"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#0DA9D5",
                          "&.Mui-checked": {
                            color: "#0DA9D5",
                          },
                        }}
                      />
                    }
                    label="Detalhamento"
                  />
                </RadioGroup>
              </FormControl>

              {selectedValue === "Gerencial" && (
                <div className="container-second-form">
                  <h3>Medida:</h3>
                  <FormControl className="container-form-control">
                    <RadioGroup
                      defaultValue="Volume C9"
                      row
                      name="row-radio-buttons-groupKpi"
                      className="radio-groupKpi radio-group-button-export"
                      value={selectedValueKpi}
                      onChange={handleChangekPI}
                      sx={{ marginLeft: "0px" }}
                    >
                      <FormControlLabel
                        value="Volume C9"
                        control={
                          <Radio
                            size="small"
                            defaultChecked
                            sx={{
                              color: "#0DA9D5",
                              "&.Mui-checked": {
                                color: "#0DA9D5",
                              },
                            }}
                          />
                        }
                        label="Volume C9"
                      />

                      <FormControlLabel
                        value="R$"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#0DA9D5",
                              "&.Mui-checked": {
                                color: "#0DA9D5",
                              },
                            }}
                          />
                        }
                        label="R$"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              )}

              <>
                {selectedValue === "Gerencial" && (
                  <div
                    style={{ height: "450px" }}
                    className="contianer-colum-cards"
                  >
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Vendas",
                      }}
                      className={"container-card-item"}
                    >
                      <NativeObject
                        app={app}
                        key="YrxSdCM"
                        reference={{ id: "YrxSdCM" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Peformance de Vendas",
                      }}
                      className={"container-card-item"}
                    >
                      <NativeObject
                        app={app}
                        key="fpYuPq"
                        reference={{ id: "fpYuPq" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  </div>
                )}

                {selectedValue === "Gerencial" && (
                  <div className="container-table-gerencial">
                    <Card
                      app={app}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      exportContainer
                      exportTable
                      exportTableId="eZuUgm"
                      header={{
                        hardTitle: "Detalhamento",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="eZuUgm"
                        reference={{ id: "eZuUgm" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  </div>
                )}

                {selectedValue === "Resumo" && (
                  <div
                    style={{ height: "30%" }}
                    className="mobile-resumo-mini-monitor item-card-01"
                  >
                    <Card
                      pp={app}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      exportContainer
                      exportTable
                      exportTableId="nBERks"
                      className={"card-resumo-item"}
                    >
                      <NativeObject
                        app={app}
                        key="nBERks"
                        reference={{ id: "nBERks" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  </div>
                )}

                {selectedValue === "Resumo" && (
                  <div style={{ height: "55%", marginTop: "10px" }}>
                    <Card
                      app={app}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      exportContainer
                      exportTable
                      exportTableId="zuTqXT"
                      className={"card-resumo-item item-card-dois"}
                    >
                      <NativeObject
                        app={app}
                        key="zuTqXT"
                        reference={{ id: "zuTqXT" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  </div>
                )}

                {selectedValue === "Detalhamento" && (
                  <div style={{ height: "85%" }}>
                    <Card
                      app={app}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      exportContainer
                      exportTable
                      exportTableId="VeGWjp"
                      className={"card-resumo-detalhe"}
                    >
                      <NativeObject
                        app={app}
                        key="VeGWjp"
                        reference={{ id: "VeGWjp" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  </div>
                )}
              </>
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

VendaExcelenteDesktop.defaultProps = {
  app: null,
  config: {},
};

VendaExcelenteDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default VendaExcelenteDesktop;
